import { InMemoryCache } from 'apollo-cache-inmemory'
import { createPrismicLink } from 'apollo-link-prismic'

export default ({ $config }) => {
    return {
        link: createPrismicLink({
            uri: $config.prismicUrl,
        }),
        cache: new InMemoryCache(),
        defaultHttpLink: false,
    }
}
